'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _elementActions = require('../../../../element/elementActions');

var _Tool = require('../../Tool');

var _Tool2 = _interopRequireDefault(_Tool);

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _lineConstants = require('../../../../../common/lines/lineConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Components


// Constants


var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        isActive: ownProps.selectedElements.first().getIn(['content', ownProps.styleProp]) === _lineConstants.LINE_MARKER_STYLE.ARROW
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchUpdateSelectedElements: function dispatchUpdateSelectedElements(_ref) {
            var changes = _ref.changes;
            return dispatch((0, _elementActions.updateSelectedElements)({ changes: changes }));
        }
    };
};

var ArrowTool = function (_React$Component) {
    _inherits(ArrowTool, _React$Component);

    function ArrowTool() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, ArrowTool);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ArrowTool.__proto__ || Object.getPrototypeOf(ArrowTool)).call.apply(_ref2, [this].concat(args))), _this), _this.toggleArrow = function () {
            var _this$props = _this.props,
                isActive = _this$props.isActive,
                styleProp = _this$props.styleProp,
                dispatchUpdateSelectedElements = _this$props.dispatchUpdateSelectedElements;

            var changes = _defineProperty({}, styleProp, isActive ? _lineConstants.LINE_MARKER_STYLE.NONE : _lineConstants.LINE_MARKER_STYLE.ARROW);
            dispatchUpdateSelectedElements({ changes: changes });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ArrowTool, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                iconDirection = _props.iconDirection,
                isActive = _props.isActive;


            var iconName = isActive ? 'toolbar-arrow-' + iconDirection + '-on' : 'toolbar-arrow-' + iconDirection;
            return _react2.default.createElement(
                _Tool2.default,
                _extends({}, this.props, { handleMouseDown: this.toggleArrow, isActive: true }),
                _react2.default.createElement(_Icon2.default, { name: iconName })
            );
        }
    }]);

    return ArrowTool;
}(_react2.default.Component);

ArrowTool.propTypes = {
    name: _propTypes2.default.string,
    isActive: _propTypes2.default.bool,
    styleProp: _propTypes2.default.string.isRequired,
    selectedElements: _propTypes2.default.object.isRequired,
    dispatchUpdateSelectedElements: _propTypes2.default.func,
    iconDirection: _propTypes2.default.string.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ArrowTool);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/arrowTools/ArrowTool.js
// module id = 788
// module chunks = 0